/** Matches backend requireBusiness: listing is travel-business vendors, not shoppers. */
const LISTING_USER_TYPES = new Set(['AGENT', 'CONSULTANT', 'BUSINESS', 'ADMIN']);

export function canUseVendorPortal(user?: { userType?: string; role?: string } | null): boolean {
  if (!user) return false;
  const t = String(user.userType || '').toUpperCase();
  const r = String(user.role || '').toUpperCase();
  return LISTING_USER_TYPES.has(t) || r === 'ADMIN' || r === 'SUPER_ADMIN';
}
